import { render } from "./EditSegurado.vue?vue&type=template&id=498cb42e"
import script from "./EditSegurado.vue?vue&type=script&lang=js"
export * from "./EditSegurado.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__